import React from 'react';
import { T } from '../assets/theme';

export default function ShieldControl({ top = 92, shieldOn, toggleShield, shieldData, shieldLoading, shieldError, projectMaxTotalElev, projectPenetratingMaxTotalElev, radiusKm, setRadiusKm, exportCsv, onExportPenetrating, penetratingCount }) {
    // Step 2 (against the project's actual penetrating obstacles) is the
    // meaningful reference when there's a penetration to shield in the first
    // place; fall back to Step 1 (project max) when there isn't one yet.
    const shieldReference = projectPenetratingMaxTotalElev ?? projectMaxTotalElev;
    const shieldCount = shieldData
        ? [...(shieldData.swot || []), ...(shieldData.sof || [])]
            .filter(r => (parseFloat(r.elev_m) || 0) + (parseFloat(r.v_tolerance_m) || 0) > (shieldReference ?? Infinity)).length
        : 0;

    return (
        <div style={{ position: 'absolute', top, right: 12, zIndex: 1000, background: 'rgba(6,14,26,0.85)', borderRadius: 8, padding: 6, border: `1px solid ${T.border}`, backdropFilter: 'blur(8px)', maxWidth: 260 }}>
            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                <button
                    onClick={toggleShield}
                    disabled={shieldLoading}
                    title="Show existing SWOT/SOF obstacles within the given radius of this project's hull — red ones are already higher than the project's tallest obstacle"
                    style={{
                        padding: '4px 10px', borderRadius: 5, border: 'none', cursor: shieldLoading ? 'wait' : 'pointer',
                        background: shieldOn ? '#e84040' : 'transparent', color: shieldOn ? '#fff' : T.muted,
                        fontSize: 11, fontWeight: 700, flex: 1,
                    }}
                >
                    {shieldLoading ? '⏳ Loading…' : `🛡 SHIELD${shieldOn ? ' ON' : ''}`}
                </button>
            </div>
            {setRadiusKm && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 6 }}>
                    <span style={{ fontSize: 10, color: T.muted }}>Radius</span>
                    <input
                        type="number"
                        min={0.1}
                        max={100}
                        step={0.5}
                        value={radiusKm}
                        onChange={e => setRadiusKm(e.target.value)}
                        disabled={shieldLoading}
                        title="Shielding search radius in km (max 100)"
                        style={{
                            width: 56, fontSize: 11, padding: '2px 5px', borderRadius: 4,
                            border: `1px solid ${T.border}`, background: 'rgba(255,255,255,0.04)', color: T.white,
                        }}
                    />
                    <span style={{ fontSize: 10, color: T.muted }}>km</span>
                </div>
            )}
            {shieldOn && shieldData && (
                <div style={{ fontSize: 10, color: T.muted, marginTop: 6, lineHeight: 1.5 }}>
                    {(shieldData.swot?.length || 0) + (shieldData.sof?.length || 0)} within {radiusKm}km ·{' '}
                    <span style={{ color: '#e84040', fontWeight: 700 }}>{shieldCount} shield</span>
                </div>
            )}
            {shieldOn && shieldData && exportCsv && ((shieldData.swot?.length || 0) + (shieldData.sof?.length || 0) > 0) && (
                <button
                    onClick={exportCsv}
                    title="Export the obstacles above as CSV (lat/lon in DMS, elevation, V-Tol, height above the project's highest obstacle)"
                    style={{
                        marginTop: 6, width: '100%', padding: '4px 8px', borderRadius: 5,
                        border: `1px solid ${T.border}`, background: 'rgba(255,255,255,0.04)', color: T.muted,
                        fontSize: 10, fontWeight: 700, cursor: 'pointer',
                    }}
                >
                    ⬇ Export CSV
                </button>
            )}
            {shieldOn && onExportPenetrating && !!penetratingCount && (
                <button
                    onClick={onExportPenetrating}
                    title="Export only candidates confirmed to genuinely penetrate a real surface at their own position (not just raw-elevation shields)"
                    style={{
                        marginTop: 4, width: '100%', padding: '4px 8px', borderRadius: 5,
                        border: '1px solid #FFE14D55', background: 'rgba(255,225,77,0.08)', color: '#FFE14D',
                        fontSize: 10, fontWeight: 700, cursor: 'pointer',
                    }}
                >
                    ⬇ Export Surface-Penetrating Only ({penetratingCount})
                </button>
            )}
            {shieldError && <div style={{ fontSize: 10, color: '#e84040', marginTop: 6 }}>{shieldError}</div>}
        </div>
    );
}
